module.exports = __webpack_public_path__ + "img/workshop3.dfaa5000.jpg";